/** Značka aplikace v <title>: „Stránka | CalibraTech 2.0“ */
export const APP_TITLE_SUFFIX = 'CalibraTech 2.0';

/**
 * URL loga aplikace (sidebar, login, favicon).
 * `?v=N` je cache-busting — favicon.png se servíruje přes Cloud CDN pod stálou
 * URL, takže při výměně loga je nutné verzi zvednout, jinak CDN/prohlížeč drží
 * starou ikonu. Musí být v souladu s `?v=` v `public/index.html`.
 */
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/favicon.png?v=2`;
